/* eslint-disable react/prop-types,no-unused-vars */

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import parlorSocialClub from "../../../../assets/graphics/icons/parlor-social-club-black.svg";
import logoWithLines from "../../../../assets/graphics/icons/logo-with-lines.svg";
import eventsIconOutline from "../../../../assets/graphics/icons/events-icon-outline.svg";
import hyperlinkIcon from "../../../../assets/graphics/icons/hyperlink-white-icon.svg";
import hyperlinkIconBlack from "../../../../assets/graphics/icons/hyperlink-black.svg";
import "screens/events/component/view.scss";
import "screens/events/component/live-event-details/view.scss";

import { format } from "date-fns";

export const LiveEventDetailsView = ({
  liveLinks,
  notes,
  eventName,
  eventDate,
  eventImages,
}) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  return (
    <>
      <div className="events__page">
        <header className="events__page__header">
          <div className="img__wrapper">
            <Link to="/">
              <img src={parlorSocialClub} alt="logo" />
            </Link>
          </div>
        </header>
        <main className="live-event-page">
          <div className="live-event">
            <div className="hero__image-container">
              <picture className="hero__image">
                <img src={eventImages.image_url_1x1} alt="" />
              </picture>
            </div>
            <section className="live-event__datetime">
              <h2 className="heading">
                <span>Live Now</span>
                <time
                  className="event-time"
                  dateTime={format(
                    new Date(
                      ...[
                        ...eventDate.split(" ")[0].split("-"),
                        ...eventDate.split(" ")[1].split(":"),
                      ]
                    ),
                    "k:mmaa"
                  )}
                >
                  {format(
                    new Date(
                      ...[
                        ...eventDate.split(" ")[0].split("-"),
                        ...eventDate.split(" ")[1].split(":"),
                      ]
                    ),
                    "k:mmaa"
                  )}
                </time>
              </h2>
            </section>
            <section className="live-event__details">
              <div className="live-event__logo">
                <img src={logoWithLines} alt="logo" />
              </div>
              <h1 className="heading heading--desktop">{eventName}</h1>
              <div className="time-container">
                <p className="event-time">Live Now</p>
              </div>
              <div className="details pt-25 hide-large">
                <div className="detail-item">
                  <img
                    src={eventsIconOutline}
                    alt=""
                    className="detail-item__adornment"
                  />
                  <h1 className="detail-item__text">{eventName}</h1>
                </div>
              </div>
              <ul className="details">
                {liveLinks.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.url}
                      className="detail-item"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <img
                        src={hyperlinkIconBlack}
                        alt=""
                        className="detail-item__adornment"
                      />
                      <img
                        src={hyperlinkIcon}
                        alt=""
                        className="detail-item__adornment detail-item__adornment--desktop"
                      />
                      <p className="detail-item__text">{link.url}</p>
                    </a>
                  </li>
                ))}
              </ul>
              {notes && notes.length > 0 && (
                <ul className="notes pt-25">
                  <h2 className="notes__title">
                    Notes <span className="notes__subtitle">for the event</span>
                  </h2>
                  {notes.map((note) => (
                    <li className="notes__item" key={note}>
                      {note}
                    </li>
                  ))}
                </ul>
              )}
              {liveLinks.length > 0 && (
                <div className="cta-container">
                  <a
                    href={liveLinks[0] && liveLinks[0].url}
                    className="outlined-button outlined-button--large outlined-button--full-width outlined-button--secondary"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Join live
                  </a>
                </div>
              )}
            </section>
          </div>
        </main>
      </div>
    </>
  );
};
